import * as z from 'zod'

import { fetchOperatorGetApiByEmail } from '@/common/api/modules/operator'
import { CreateOperatorVars, UpdateOperatorVars } from '@/common/api/params/operator'
import { NameLabelMapping } from '@/common/app/message'
import {
  CODE_UNIQUE_MESSAGE,
  PASSWORD_MASKING,
  StringLength,
  makeValidateCodeUnique,
  validatePassword
} from '@/common/form/schema'
import { Operator } from '@/common/model/operator'

// W2 オペレーター（全体管理者）。ログインIDは email。サイト・権限テンプレートは持たない。
export const operatorSchema = z
  .object({
    id: z.number().readonly().optional(),
    email: z.email().max(StringLength.NORMAL_MAX),
    password: validatePassword().or(z.literal(PASSWORD_MASKING)),
    name: z.string().min(1).max(StringLength.NORMAL_MAX)
  })
  .refine(
    async ({ id, email }) => {
      const validateUnique = makeValidateCodeUnique(async (email: string) => {
        const data = await fetchOperatorGetApiByEmail(email)
        return data ? data.id : undefined
      })
      return await validateUnique(id, email)
    },
    {
      message: CODE_UNIQUE_MESSAGE,
      path: ['email']
    }
  )

export type OperatorFormSchemaType = z.infer<typeof operatorSchema>

export const convertOperatorSchemaToVars = (
  schema: OperatorFormSchemaType
): UpdateOperatorVars | CreateOperatorVars => {
  if (schema.id !== undefined) {
    return {
      operator_id: schema.id,
      email: schema.email,
      ...(schema.password && schema.password !== PASSWORD_MASKING && { password: schema.password }),
      name: schema.name
    }
  }
  return {
    email: schema.email,
    password: schema.password,
    name: schema.name
  }
}

export const convertOperatorToSchema = (operator: Operator): OperatorFormSchemaType => {
  return {
    id: operator.id,
    email: operator.email,
    password: PASSWORD_MASKING,
    name: operator.name
  }
}

export const DEFAULT_OPERATOR_SCHEMA: OperatorFormSchemaType = {
  email: '',
  password: '',
  name: ''
}

export const operatorNameLabelMapping: NameLabelMapping = {
  email: 'メールアドレス',
  password: 'パスワード',
  name: '名前'
}
